import { render } from "./TransitionPage.vue?vue&type=template&id=58711130"
import script from "./TransitionPage.vue?vue&type=script&lang=js"
export * from "./TransitionPage.vue?vue&type=script&lang=js"

import "./TransitionPage.vue?vue&type=style&index=0&id=58711130&lang=scss"

import exportComponent from "/home/runner/work/lifepass-passes-app/lifepass-passes-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__